import { SafeHtml } from "@angular/platform-browser";
export interface AddEvent {
  title: string;
  eventdate: string | Date;
  venue: string;
  timefrom: string;
  timeto: string;
  timezone: string;
  googlemapurl: string;
  description: string;
  attendees_userid: string[];
  group_id: string[];
  client_id: string[];
  event_id: string;
}

export interface EventsList {
  description: string;
  event_id: string;
  eventdate: string | Date;
  googlemapurl: string;
  organiser: string;
  timefrom: string;
  timeto: string;
  timeRange: string;
  timezone: string;
  title: string;
  venue: string;
  event_status: string;
  organiser_firstname: string;
  organiser_lastname: string;
  organiser_fullname: string;
  status: string;
  [key: string]: any;
  total_record: any;
}

export interface EventDetailResponse {
  event_details: {
    description: string;
    event_id: string;
    eventdate: Date | string;
    googlemapurl: string | SafeHtml;
    organiser: string;
    organiser_fname: string;
    organiser_lname: string;
    organiser_fullname: string;
    timefrom: string;
    timeto: string;
    timezone: string;
    title: string;
    venue: string;
    timeRange: SafeHtml;
    event_status: string;
  }
  userdata: EventUserDetail[];
  attendees: string[];
  groupDetails: EventGroupDetail[];
  clientDetails: EventClientDetail[];
}

export interface EventDetail {
  description: string;
  event_id: string;
  eventdate: Date | string;
  googlemapurl: string | SafeHtml;
  organiser: string;
  organiser_fname: string;
  organiser_lname: string;
  organiser_fullname: string;
  timefrom: string;
  timeto: string;
  timezone: string;
  title: string;
  venue: string;
  timeRange: SafeHtml;
  event_status: string;
  userdata: EventUserDetail[];
  attendees: string[];
  groupDetails: EventGroupDetail[];
  clientDetails: EventClientDetail[];
}

export interface EventClientDetail {
  client_id: string;
  company_emailid: string;
  company_name: string;
  status: string;
}

export interface EventGroupDetail {
  group_id: string;
  group_name: string;
}
export interface EventUserDetail {
  event_status: string;
  user_firstname: string;
  user_id: string;
  user_lastname: string;
}

export interface RevertStatus {
  event_id: string;
  userFullname: string;
  event_status: string;
}
